<template>
  <div>
    <el-form-item label="占位内容" label-width="100px" label-position="left">
      <el-input v-model="data.placeholder"
                placeholder="自动计算"></el-input>
    </el-form-item>
    <el-form-item label="数值精度" v-if="data.formulaType !== 'date'">
      <el-input-number v-model="data.precision"
                       controls-position="right"
                       placeholder="数值精度"
                       :min="0"
                       :max="10"></el-input-number>
    </el-form-item>
    <el-form-item label="公式类型">
      <el-select placeholder="请选择公式类型" v-model="data.formulaType">
        <el-option v-for="item in formulaType"
        :key="item.label"
        :label="item.label"
        :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <div class="pop" @click="handleOpen">
      <span class="font1">计算公式 = </span>
      <span class="vhtml" v-html="data.showContent" />
    </div>
    <el-form-item label="是否只读">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="列隐藏" v-if="isDynamic">
      <el-switch v-model="data.hide"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>

    <el-form-item label="正则校验：">
      <el-input v-model.lazy="data.pattern"
      placeholder="正则表达式"></el-input>
    </el-form-item>
    <template v-if="isOpen">
      <Modal
      :isOpen.sync="isOpen"
      :item="data"
      :widgetForm="widgetForm"
      @on-save="handleSave" />
    </template>
  </div>
</template>

<script>
import mixinIsDynamic from '../../../mixins/isDynamic'
import Modal from './Modal'
import { formulas } from './index'
export default {
  mixins: [mixinIsDynamic],
  components: {
    Modal
  },
  props: ['data', 'widgetForm'],
  data() {
    return {
      isOpen: false,
      formulaType: [{
        value: formulas.number,
        label: '数字'
      }, {
        value: formulas.timeDifference,
        label: '时差'
      }, {
        value: formulas.timeDifferenceRange,
        label: '范围时差'
      }, {
        value: formulas.date,
        label: '时间'
      }]
    }
  },
  methods: {
    handleOpen() {
      this.isOpen = true
    },
    handleSave({ showContent, content, labels, values, firstDateProp, secondDateProp, dateUnit, addOrSubtract, timeType }) {
      this.data.showContent = showContent
      if (content) {
        this.data.content = content
      }
      if (labels.length) {
        this.data.labels = labels
      }
      if (values.length) {
        this.data.values = values
      }
      if (firstDateProp) {
        this.data.firstDateProp = firstDateProp
      }
      if (secondDateProp) {
        this.data.secondDateProp = secondDateProp
      }
      if (dateUnit) {
        this.data.dateUnit = dateUnit
      }
      if (addOrSubtract) {
        this.data.addOrSubtract = addOrSubtract
      }
      if (timeType) {
        this.data.timeType = timeType
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pop {
  border: 1px solid #CCC;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  color: #000;
}
.font1 {
  color: #666;
}
</style>
